import React, {useEffect} from "react";
import MessageList from "./MessageList";
import TopPane from "./TopPane";
import SendForm from "./SendForm";


import {IonPage} from '@ionic/react';
import {useDispatch} from "react-redux";
import {setActiveChat, setActiveChatChatWindow} from "../../../actions/Chats";

const Index = (
    {
        socket,
    }
) => {
    const dispatch = useDispatch();
    useEffect(()=>{
        return ()=>{
            dispatch(setActiveChat(null));
            dispatch(setActiveChatChatWindow(null));
        }    },[])
    return <IonPage>
        <TopPane/>
        <MessageList socket={socket}/>
        <SendForm/>
    </IonPage>;
};

export default Index;
